import { useState } from "react";
import { ConsoleShell, PageHead } from "../components/ConsoleShell.js";
import { EmptyState } from "../components/EmptyState.js";
import { Tabs, TabPanel } from "../components/Tabs.js";
import { BtnLink } from "../components/Btn.js";
import { Icon } from "../components/Icon.js";

/** Status lanes for the future feedback queue (no data yet — collection isn't wired up). */
const STATUS_TABS = [
  { id: "open", label: "未対応" },
  { id: "doing", label: "対応中" },
  { id: "done", label: "解決済み" },
] as const;

/**
 * 現場フィードバック — まだ収集APIが無いため、正直な「準備中」を表示する。
 * 将来: 閲覧者が手順ごとに「分かりにくい」を報告 → ここで集約し、改善キュー（再撮影・表追加・bbox指示）に
 * 流す。ステータス（未対応 / 対応中 / 解決済み）はその時のレーン構造をそのまま残してある。
 * 偽の一覧・傾向バナーは撤去済み（デモデータ厳禁）。
 */
export function Feedback() {
  const [tab, setTab] = useState<string>("open");

  return (
    <ConsoleShell breadcrumb={["TEBIKI", "フィードバック"]}>
      <PageHead title={<>現場の<span className="hl">フィードバック</span></>}>
        「分かりにくい」報告を集約し、改善キューへ。どの手順でつまずいたかが分かる。
      </PageHead>

      <Tabs
        active={tab}
        onChange={setTab}
        ariaLabel="フィードバックのステータス"
        tabs={STATUS_TABS.map((t) => ({ id: t.id, label: t.label }))}
      />

      {STATUS_TABS.map((t) => (
        <TabPanel key={t.id} id={t.id} active={tab}>
          <EmptyState icon={<Icon name="feedback" size={30} />} title="現場フィードバックは準備中です">
            閲覧者が手順ごとに送った「分かりにくい」報告を、つまずいた手順とともにここへ集約します。
            ステータス（未対応 / 対応中 / 解決済み）で仕分けし、再撮影・表の追加・操作箇所の図示といった改善キューへ流せるようにします。
            <br />
            それまでは、公開中のマニュアルを点検しながら改善できます。
          </EmptyState>
          <div style={{ display: "flex", justifyContent: "center", marginTop: 4 }}>
            <BtnLink to="/library" variant="ghost" icon={<Icon name="library" />}>
              ライブラリを開く
            </BtnLink>
          </div>
        </TabPanel>
      ))}
    </ConsoleShell>
  );
}
